<template>
  <div class="app">
    <div class="beijing">
      <!-- 登录框 -->
      <div class="head01">
        <div class="head02">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
          <div>&nbsp;&nbsp;&nbsp;通未来-职业规划大师</div>
          <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;VIP热线：1391 0303 798</div>
        </div>
        <div style="display: flex; align-items: center;">
          <span @click="selectLogin($event)" :class="{ selected: selectedType === 'qiye' }"> 我要招聘&nbsp;</span>/
          <span @click="selectLogin($event)" :class="{ selected: selectedType === 'student' }">&nbsp;我要规划职业 </span>
          <span class="head03"> 登录&nbsp;</span>/
          <span style="cursor: pointer;" @click="goToRegister">&nbsp;注册 </span>
        </div>
      </div>
      <div class="juzhong" style="gap:30px;flex-direction: column;">
        <div style="margin-top: 4%;">
          <div class="yangshi">更合适的工作，更优秀的你</div>
          <div class="yangshi1">职业规划，开启未来</div>
        </div>
        <div class="juzhong">
          <div style="margin-top: 5%;">
            <div style="margin-top: 6%;"><img :src="index" alt="更合适的工作，更优秀的你 职业规划，开启未来" class="tupian">
            </div>
          </div>
          <div class="fangkuan">
            <img :src="require('@/components/img/logo.png')" style="margin-top: 10px;width:20%;">
            <div class="juzhong1" style="gap:40px">
              <div class="denglu" @click="selectLogin($event)" :class="{ selected: selectedType === 'student' }">
                我是学生
              </div>
              <div class="denglu" @click="selectLogin($event)" :class="{ selected: selectedType === 'qiye' }">
                我是企业
              </div>
            </div>
            <div class="jufen" style="height:231px;">
              <div>
                <el-input placeholder="请输入手机号" prefix-icon="el-icon-phone" v-model="phoneNumber" style="width: 300px;"
                  type="text" v-show="selectedType === 'student'" minlength="11">
                </el-input>
                <el-input placeholder="请输入税号/手机号" prefix-icon="el-icon-phone" v-model="taxNumber" style="width: 300px;"
                  type="text" v-show="selectedType === 'qiye'" minlength="11">
                </el-input>
              </div>
              <div>
                <el-input placeholder="请输入密码" prefix-icon="el-icon-lock" v-model="password" style="width: 300px;"
                  show-password>
                </el-input>
              </div>
              <div style="display:flex;gap:10px;">
                <el-input placeholder="请输入验证码" prefix-icon="el-icon-key" v-model="yanzhengma" style="width:197px;">
                </el-input>
                <img class="codeimg" :src="imgsrc" @click="changeimg" alt="" />
              </div>
              <div v-show="error" style="margin-left: 20px;color:red;font-size: 14px;">{{ errorName }}</div>
              <div class="login" @click="login">登录</div>
            </div>
            <div class="zhuce" @click="goToRegister">去注册</div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from './Footer.vue'
export default {
  name: 'index',
  components: {
    Footer
  },
  data() {
    return {
      taxNumber: '',
      phoneNumber: '',
      password: '',
      xitongyanzheng: '',
      yanzhengma: '',
      imgsrc: "@/../static/img/code.png",
      selectedType: 'student',
      error: false,
      errorName: '',
      BASE_URL: 'https://zhiyedashi.com/info',
      BASE_URL1: 'https://zhiyedashi.com/school',
      // BASE_URL: 'http://192.168.2.8:8206',
      index: require('@/components/img/index.jpg'),
      rcdistrict: []
    }
  },
  mounted() {
    this.changeimg();
    this.selectcr()
  },
  methods: {
    transformDistrictData(data) {
      return data.map(item => {
        const transformedItem = {
          value: item.district,
          label: item.district,
        };
        // 如果有子节点，递归处理
        if (item.children && item.children.length > 0) {
          transformedItem.children = this.transformDistrictData(item.children);
        }
        return transformedItem;
      });
    },
    selectcr() {
      fetch(`${this.BASE_URL}/admin/rc/province`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(res => res.json())
        .then(data => {
          this.rcdistrict = this.transformDistrictData(data.data)
          localStorage.setItem("rc", JSON.stringify(this.rcdistrict));
          if (localStorage.getItem("allSchool")) {
            console.log("exit");
          } else {
            this.selectSchool()
          }
        })
        .catch(error => {
          console.error("地址查询失败，原因是", error);
        });
    },
    selectSchool() {
      fetch(`${this.BASE_URL1}/admin/school/selectAllSchool`, {
        method: 'post'
      })
        .then(res => res.json())
        .then(data => {
          // console.log("所有学校", data);
          const yuanxiaos = data.map(item => ({
            label: item.schoolName,
            yuanxiao: item.schoolName,
          }));
          localStorage.setItem("allSchool", JSON.stringify(yuanxiaos))
        })
        .catch(error => {
          console.error("查询学校失败，原因是", error);
        })
    },
    login() {
      // 先判断账号密码是不是空
      if (this.xitongyanzheng.toLowerCase() !== this.yanzhengma.toLowerCase()) {
        this.error = true
        this.errorName = '验证码输入不正确，请重新尝试。'
        this.yanzhengma = ''
        this.changeimg()
      } else {
        if (this.selectedType === 'student') {
          if (this.phoneNumber !== '' && this.password !== '' && this.yanzhengma !== '') {
            // 学生端
            fetch(`${this.BASE_URL}/admin/user/login/enter`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: `phoneNumber=${this.phoneNumber}&password=${this.password}`
            })
              .then(res => res.json())
              .then(data => {
                // console.log("登录的data", data);
                if (data.data === '用户存在') {
                  alert("登录失败，请检查账号和密码是否正确");
                  this.changeimg()
                } else if (data.data === '去注册') {
                  alert("用户不存在，请先注册账号");
                  this.$router.push('/register')
                } else {
                  let id = data.data.split("登录成功")[1]
                  localStorage.removeItem("dataTable")
                  sessionStorage.setItem("userId", id)
                  this.$router.push('/userInfo')
                }
              })
              .catch(error => {
                console.error("登录失败，原因是", error);
                this.changeimg()
              });
          } else {
            // 没有数据
            this.error = true
            this.errorName = '请确保数据完整，不能为空哦~'
          }
        } else {
          if (this.taxNumber !== '' && this.password !== '' && this.yanzhengma !== '') {
            fetch(`${this.BASE_URL}/admin/enterprise/login/enter`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: `taxNumber=${this.taxNumber}&password=${this.password}`
            })
              .then(res => res.json())
              .then(data => {
                // console.log("登录的data", data);
                if (data.code === 201) {
                  alert("登录失败，请检查账号和密码是否正确")
                  this.changeimg()
                } else {
                  let id = data.data.split("登录成功")[1]
                  sessionStorage.setItem("qiyeId", id)
                  this.$router.push('/corpinfo')
                  localStorage.removeItem("dataTable")
                }
              })
              .catch(error => {
                console.error("登录失败，原因是", error);
                this.changeimg()
              });
          } else {
            // 没有数据
            this.error = true
            this.errorName = '请确保数据完整，不能为空哦~'
          }
        }
      }
    },
    selectLogin(event) {
      // 移除所有元素的选中状态
      const items = document.querySelectorAll('.shenfen');
      items.forEach(item => item.classList.remove('selected'));

      // 为当前点击的元素添加选中状态
      event.target.classList.add('selected');
      if (event.target.innerText === '我是学生' || event.target.innerText.includes("我要规划职业")) {
        this.selectedType = 'student'
      } else {
        this.selectedType = 'qiye'
      }
    },
    changeimg() {
      this.cranscode = ""
      if (this.disableButton) {
        return
      }
      this.disableButton = true
      fetch(`${this.BASE_URL}/admin/user/login/getyanzheng`, {
        method: 'POST',
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.blob();
        })
        .then(blob => {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.imgsrc = reader.result;
          };
          reader.readAsDataURL(blob);

          return fetch(`${this.BASE_URL}/admin/user/login/getcode`, {
            method: 'POST',
          });
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          this.xitongyanzheng = data.data; // 更新cranscode的值
        })
        .catch(error => {
          console.error("Error", error);
        });

      setTimeout(() => {
        this.disableButton = false
      }, 1000)
    },
    goToRegister() {
      this.$router.push('/register')
    },
    goToPersonalInf() {
      this.$router.push('/personalInf')
    },
    goToCorpInfo() {
      this.$router.push('/corpinfo')
    },
    goToNewjob() {
      this.$router.push('/newjob')
    },
    goToResearchrep() {
      this.$router.push('/researchrep')
    },
    goToCvscreening() {
      this.$router.push('/cvscreening')
    },
  }
}
</script>

<style scoped>
.head01 {
  height: 60px;
  border-bottom: 1px solid white;
  display: flex;
  color: white;
  align-items: center;
  font-size: 22px;
  justify-content: space-between;
  padding: 0px 30px;
}

.head02 {
  display: flex;
  height: 60px;
  align-items: center;
}

.head03 {
  margin-left: 20px;
  cursor: pointer;
}

.logo {
  width: 48px;
  text-align: left;
}

.tupian {
  width: 600px;
  height: 347px;
}

.yangshi {
  color: white;
  font-size: 36px;
  font-weight: 800;
}

.yangshi1 {
  color: white;
  font-size: 30px;
  font-weight: 800;
}

.beijing {
  background-color: #5c8bfd;
  height: 98vh;
  width: 100%;
}

.fangkuan {
  height: 380PX;
  width: 370PX;
  background-color: #fefefe;
  margin-top: 8vh;
  border-radius: 30px;
}

.juzhong {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 180px;
}

.juzhong1 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 180px;
}

.denglu {
  padding: 5px 15px;
  font-weight: 700;
  font-size: 22px;
  border: 1px solid #c5ced7;
  border-radius: 10px;
  cursor: pointer;
}

.denglu.selected {
  background-color: #3f4e63;
  color: white;
}

.login {
  padding: 9px 83px;
  background-color: #2f78f8;
  color: white;
  border-radius: 15px;
  cursor: pointer;
}

.jufen {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  align-items: center;
  flex-direction: column;
}

.zhuce {
  text-align: right;
  margin-right: 30px;
  font-size: 13px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .head01 {
    height: 50px;
    font-size: 8px;
    padding: 0px 15px;
  }

  .head02 {
    height: 50px;
  }

  .head03 {
    margin-left: 15px;
  }

  .logo {
    width: 40px;
  }

  .tupian {
    width: 100%;
    height: auto;
    max-width: 300px;
  }

  .yangshi {
    font-size: 24px;
  }

  .yangshi1 {
    font-size: 20px;
  }

  .beijing {
    height: auto;
    min-height: 100vh;
  }

  .fangkuan {
    height: auto;
    width: 90%;
    margin-top: 5vh;
    border-radius: 20px;
    padding: 20px 0;
    margin-bottom: 15px;
  }

  .juzhong {
    gap: 30px;
    flex-direction: column;
  }

  .juzhong1 {
    gap: 30px;
  }

  .denglu {
    font-size: 18px;
    padding: 4px 12px;
  }

  .login {
    padding: 8px 60px;
    border-radius: 12px;
  }

  .jufen {
    height: auto;
    gap: 15px;
  }

  .zhuce {
    margin-right: 20px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue